import { api, getIn18Text, locationHelper } from 'api';
import cloneDeep from 'lodash/cloneDeep';
import { getSendCount } from '@/components/Layout/Customer/components/hooks/useEdmSendCount';
const systemApi = api.getSystemApi();
const codeMessageMap = {
    106312: getIn18Text('importFormatError'),
    106309: getIn18Text('importMaxError'),
    106314: getIn18Text('ZANWULIANXIREN'),
    106318: getIn18Text('importTimeout'),
    106316: getIn18Text('importOnceMoreError'),
    106317: getIn18Text('importFileSizeError'),
};
export const getContactErrorTxt = (code) => {
    return code ? codeMessageMap[code] : undefined;
};
export const getColor = (email) => {
    const colors = ['#6BA9FF', '#70CCAB', '#AA90F4', '#F7A87C'];
    const emailMd5 = systemApi.md5(email);
    return colors[parseInt(emailMd5[emailMd5.length - 1], 16) % 4];
};
const chineseSymbolList = ['。', '；', '，', '：', '“', '”（', '）', '、', '？', '《', '》', '【', '】', '〈', '〉', '『', '』'];
const replaceChiniseSymbol = (str) => {
    return chineseSymbolList.reduce((acc, symbol) => {
        while (acc.indexOf(symbol) !== -1) {
            acc = acc.replace(symbol, '');
        }
        return acc;
    }, str);
};
const chineseDoublenamelist = ['欧阳', '太史', '司马', '独孤', '夏侯', '诸葛', '尉迟', '公冶', '公孙', '慕容', '长孙', '宇文', '令狐'];
const testDoubleNames = (name) => {
    return (name.length === 3 &&
        chineseDoublenamelist.some(subName => {
            return name.startsWith(subName);
        }));
};
const unitSuffixList = ['组', '部', '委员会', '团队'];
const testUnitSuffix = (name, suffixList) => {
    return suffixList.findIndex(item => {
        return name.endsWith(item) && name.length - item.length >= 2;
    });
};
const replaceUnitSuffix = (name, unitLen) => {
    return name.slice(name.length - 2 - unitLen, name.length - unitLen);
};
export const getCharAvatar = (name) => {
    if (typeof name !== 'string' || !name || !name.trim()) {
        return name;
    }
    let resChar;
    try {
        name = replaceChiniseSymbol(name.trim());
        const charList = [...name];
        resChar = charList[0];
        const hasCharacter = /[\u4e00-\u9fa5]/.test(name);
        if (hasCharacter) {
            const defaultName = name.slice(-2);
            const matchUnitIndex = testUnitSuffix(name, unitSuffixList);
            if (matchUnitIndex >= 0) {
                resChar = replaceUnitSuffix(name, matchUnitIndex);
            }
            else if (testDoubleNames(name)) {
                resChar = name.slice(0, 2);
            }
            else {
                resChar = defaultName;
            }
        }
        else if (name.length >= 1) {
            resChar = name.slice(0, 1).toLocaleUpperCase();
        }
    }
    catch (e) {
        console.warn(e);
    }
    return resChar;
};
export const fixContactLabel = (label) => (label === '|' ? '#' : label);
export const contact4ui = (list, pointLabel) => {
    const labels = new Set();
    if (!list) {
        return [];
    }
    const res = cloneDeep(list).map(e => {
        const r = e;
        r.contact.defaultEmail = e.contact.accountName;
        r.contact.charAvatar = getCharAvatar(e.contact.contactName);
        if (pointLabel) {
            if (!labels.has(r.contact.contactLabel)) {
                r.contact.labelPoint = !0;
                labels.add(r.contact.contactLabel);
            }
            else {
                r.contact.labelPoint = false;
            }
        }
        return r;
    });
    return res;
};
export function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
export const splitSearchHit = (hit, text) => {
    if (!text) {
        return null;
    }
    const searchText = escapeRegExp(hit.slice());
    const reg = new RegExp(searchText, 'i');
    const result = reg.exec(text.slice());
    if (!result) {
        return null;
    }
    const head = text.substring(0, result.index);
    const target = text.substring(result.index, result.index + hit.length);
    const tail = text.substring(result.index + hit.length);
    return {
        head,
        target,
        tail,
    };
};
export const contactFormToParams = (values) => {
    const params = {
        emailList: values.emailList,
        name: values.contactName.trim(),
        comment: values.remark,
        phoneList: values.mobileList,
        groupIdList: values.personalOrg,
        isMark: values.isMark,
        adrList: values.adrList,
        pref: values.pref,
        birthday: values.birthday,
        role: values.role,
        title: values.title,
        org: values.org,
        orgname: values.orgname,
    };
    return params;
};
export const personalOrgToYingxiao = (list) => {
    if (list === null || list === void 0 ? void 0 : list.length) {
        const emailSet = new Set();
        const emailList = list.reduce((arr, item) => {
            var _a;
            if ((_a = item.emailList) === null || _a === void 0 ? void 0 : _a.length) {
                item.emailList.forEach(email => {
                    if (!emailSet.has(email)) {
                        arr.push({
                            contactName: item.name,
                            contactEmail: email,
                            sourceName: '个人通讯录',
                            increaseSourceName: 'personalOrg',
                        });
                        emailSet.add(email);
                    }
                });
            }
            return arr;
        }, []);
        getSendCount({
            emailList,
            from: 'personalOrg',
            back: locationHelper.getHash(),
        });
    }
    else {
        console.error('contact_util personalOrgToYingxiao', '请传入有效的联系人');
    }
};
